import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { EnumApprovalState } from "@/models/enum/Enum";
import { useRouter } from "vue-router/composables";
import { $post } from "@/plugins/api/api";
import { $get } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { ApprovalAttendanceResponse } from "@/models/approval/ApprovalResponse";
import { ApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { PetitionShiftAttendanceSearchRequest } from "@/models/nopetition/PetitionShiftAttendanceSearchRequest.vue";
import { useApproval } from "@/composable/Approval";

type Banner = {
  mainText: string;
  subText?: string;
  color: string;
  index: ApprovalIndex;
};

type Banner2 = {
  text: string;
  color: string;
};

type ApprovalType = keyof typeof ApprovalType;

type ApprovalIndex = typeof ApprovalIndex[keyof typeof ApprovalIndex];


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountantHome',
  setup(__props) {

const router = useRouter();
const approval = useApproval();

const ApprovalType = {
  Shift: "シフト申請",
  Vacation: "休暇申請",
  Overwork: "残業申請",
  Attendance: "勤務時間変更依頼",
  Earlytime: "早出申請"
} as const;
const ApprovalIndex = {
  WorkSchedule: 0,
  Vacation: 1,
  Shift: 2,
  Overwork: 3,
  Attendance: 4,
  Earlytime: 5
} as const;
const routerName = "ApprovalStatus";
const routerName2 = "/AlertDetailList";

const items = ref<Banner[]>([]);
const items2 = ref<Banner2[]>([]);

const getBanner = (type: ApprovalType, allCount = 0, selfCount = 0): Banner => {
  const text = ApprovalType[type];
  const index = ApprovalIndex[type];

  return allCount > 0
    ? {
        mainText: `承認可能な${text}が${allCount}件あります。`,
        subText: `内、承認対象の申請が${selfCount}件あります。`,
        color: selfCount === 0 ? "orange" : "red",
        index
      }
    : { mainText: `未承認の${text}はありません。`, color: "blue", index };
};

const getBanner2 = (count = 0): Banner2 => {
  console.log("count", count);
  return count > 0
    ? { text: `未申請のアラートがあります。`, color: "red" }
    : { text: `未申請のアラートはありません。`, color: "blue" };
};

const getAllCount = async (path: string): Promise<number> => {
  const request: ApprovalSearchRequest = {
    approvals: [EnumApprovalState.WAITING, EnumApprovalState.UNAPPROVAL]
  };
  const response = await $post<ApprovalAttendanceResponse[]>(path, request);
  return response ? response.length : 0;
};

const getSelfCount = async (path: string): Promise<number> => {
  const request: ApprovalSearchRequest = {
    approvals: [EnumApprovalState.WAITING]
  };
  const response = await $post<ApprovalAttendanceResponse[]>(path, request);
  return response ? response.length : 0;
};

const getSelfCount2 = async (path: string): Promise<number> => {
  const request: PetitionShiftAttendanceSearchRequest = {
    lostStamp: 1,
    lateStamp: 1,
    earlyStamp: 1,
    overwork: 1,
    holyWork: 1,
    notStamp: 0
  };
  const encode = encodeURI(JSON.stringify(request));
  const response = await $get(path, "query=" + encode);
  console.log("response", response.items.length);
  return response.items.length;
};

const getShiftCount = async () => {
  // const path = Paths.approval.shift.search;
  const path = Paths.approval.shift.searchhome;
  const [all, self] = await Promise.all([
    getAllCount(path),
    getSelfCount(path)
  ]);
  return getBanner("Shift", all, self);
};

const getVacationCount = async () => {
  // const path = Paths.approval.vacation.search;
  const path = Paths.approval.vacation.searchhome;
  const [all, self] = await Promise.all([
    getAllCount(path),
    getSelfCount(path)
  ]);
  return getBanner("Vacation", all, self);
};

const getOverworkCount = async () => {
  // const path = Paths.approval.overtimeWork.search;
  const path = Paths.approval.overtimeWork.searchhome;
  const [all, self] = await Promise.all([
    getAllCount(path),
    getSelfCount(path)
  ]);
  return getBanner("Overwork", all, self);
};

const getAttendanceCount = async () => {
  // const path = Paths.approval.attendance.search;
  const path = Paths.approval.attendance.searchhome;
  const [all, self] = await Promise.all([
    getAllCount(path),
    getSelfCount(path)
  ]);
  return getBanner("Attendance", all, self);
};

const getEarlytimeCount = async () => {
  // const path = Paths.approval.earlytime.search;
  const path = Paths.approval.earlytime.searchhome;
  const [all, self] = await Promise.all([
    getAllCount(path),
    getSelfCount(path)
  ]);
  return getBanner("Earlytime", all, self);
};

const getAlertItems = async (): Promise<Banner2> => {
  const path = Paths.alert.list;
  const response = await getSelfCount2(path);
  console.log("countresponse", response);
  return getBanner2(response);
};

const getItems = async () => {
  return await Promise.all([
    getShiftCount(),
    getVacationCount(),
    getOverworkCount(),
    getAttendanceCount(),
    getEarlytimeCount()
  ]);
};

const getItems2 = async () => {
  return await Promise.all([getAlertItems()]);
};

const onAll = (item: Banner) => {
  approval.setAccountant();
  router.push({ name: routerName, params: { value: String(item.index) } });
};

const onOnlyApproval = (item: Banner) => {
  approval.resetForm();
  router.push({ name: routerName, params: { value: String(item.index) } });
};

const onOnlyAlert = (item: Banner2) => {
  approval.resetForm();
  router.push(routerName2);
};

onMounted(async () => {
  items.value = await getItems();
  items2.value = await getItems2();
});

return { __sfc: true,router, approval, ApprovalType, ApprovalIndex, routerName, routerName2, items, items2, getBanner, getBanner2, getAllCount, getSelfCount, getSelfCount2, getShiftCount, getVacationCount, getOverworkCount, getAttendanceCount, getEarlytimeCount, getAlertItems, getItems, getItems2, onAll, onOnlyApproval, onOnlyAlert }
}

})